import styled from "@emotion/styled";
import { Typography } from "@mui/material";

export const LinkText = styled(Typography)({
  cursor: "pointer",
  textDecoration: "underline",
  color: "#0275d8",
});
